import { useTranslation } from "react-i18next";
import { SubmitHandler } from "react-hook-form";
import { usePostApiAccountFavoritesByFavoriteListIdItemsMutation } from "api/generatedApi";
import { useDialog } from "shared/dialog/use-dialog";
import { ResultDialogType, useMutation } from "utils/hooks/use-mutation";
import { CreateItemDialog, CreateItemFormData } from "../favorite-list-components/create-item-dialog";
import { useToast } from "shared/toast/hooks/use-toast";

const DuplicateErrorCode = 409;

interface Props {
  ListId?: string;
}

export function useCreateItem(props: Props) {
  const { t } = useTranslation();

  const toast = useToast();

  const [openCreateItemDialog, closeCreateItemDialog] = useDialog(CreateItemDialog);
  const [createItem] = usePostApiAccountFavoritesByFavoriteListIdItemsMutation();

  const handleSuccess = () => {
    closeCreateItemDialog();
  };

  const wrapMutation = useMutation({
    onSuccess: handleSuccess,
    successProps: {
      description: t("account.favorites.createItemToastSuccess"),
    },
    onError: (error) => toast.error(error?.status === DuplicateErrorCode ? t("account.favorites.itemCreateDuplicateError") : t("account.favorites.itemCreateError")),
    resultDialogType: ResultDialogType.Toast,
  });

  const handleOnSubmit: SubmitHandler<CreateItemFormData> = (data) => {
    const favId = data.workitemType === "Material" ? data.material.id : data.operation.operationId;
    wrapMutation(
      createItem({
        favoriteListId: props.ListId ?? "",
        addFavoriteToPersonalFavoriteListRequest: {
          catalogItemId: favId ?? "",
          catalogItemNumber: data.workitemType === "Material" ? data.material.eanNumber : data.operation.operationNumber,
          catalogItemText: data.workitemType === "Material" ? data.material.name : data.operation.operationText,
          catalogItemUnit: data.workitemType === "Material" ? data.material.unit : "",
          catalogType: data.workitemType,
        },
      })
    );
  };

  const handleClick = () => {
    openCreateItemDialog({ onSubmit: handleOnSubmit });
  };

  return handleClick;
}
